import { render, staticRenderFns } from "./p04.vue?vue&type=template&id=15662fc0&scoped=true&"
import script from "./p04.vue?vue&type=script&lang=js&"
export * from "./p04.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15662fc0",
  null
  
)

export default component.exports